import { render, staticRenderFns } from "./tel-water.vue?vue&type=template&id=5ae8af32&scoped=true"
import script from "./tel-water.vue?vue&type=script&lang=ts"
export * from "./tel-water.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8af32",
  null
  
)

export default component.exports